import {
  KLAVIYO_ACCOUNTS,
  KLAVIYO_API_KEY,
  KLAVIYO_API_KEYS,
  KLAVIYO_EVENTS,
  KLAVIYO_LISTS,
  KLAVIYO_OAUTH_URL,
  KLAVIYO_REVENUE,
  KLAVIYO_REVOKE_TOKEN,
} from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class KlaviyoController extends AuthenticatedController {
  static async getLists(
    facebookPageId,
    tokenId: number,
    tokenType: 'api_key' | 'oauth_token',
    force: boolean = false,
  ) {
    return super.get(KLAVIYO_LISTS, {
      facebook_page_id: facebookPageId,
      token_id: tokenId,
      token_type: tokenType,
      force,
    });
  }

  static async getRevenue(facebookPageId, force: boolean = false) {
    return super.get(KLAVIYO_REVENUE, {
      facebook_page_id: facebookPageId,
      force,
    });
  }

  static async getEvents(facebookPageId, force: boolean = false) {
    return super.get(KLAVIYO_EVENTS, {
      facebook_page_id: facebookPageId,
      force,
    });
  }

  static async getOauthUrl(tokenId?: number) {
    const query = tokenId ? { token_id: tokenId } : undefined;
    return super.get(KLAVIYO_OAUTH_URL, query);
  }

  static async getApiKeys(facebokPageId: number) {
    return super.get(KLAVIYO_API_KEYS, {
      facebook_page_id: facebokPageId,
    });
  }

  static async createApiKey(privateKey: string) {
    return super.post(KLAVIYO_API_KEYS, { privateKey });
  }

  static async updateApiKey(id: number, privateKey: string) {
    return super.put(KLAVIYO_API_KEY(id), { privateKey });
  }

  static async getAccounts(facebokPageId: number) {
    return super.get(KLAVIYO_ACCOUNTS, {
      facebook_page_id: facebokPageId,
    });
  }

  static async revokeToken(tokenId: number) {
    return super.post(KLAVIYO_REVOKE_TOKEN, {
      token_id: tokenId,
    });
  }
}
